:host {
  display: block;

  p {
    padding: 12px $baseline-2;
  }
}

:host(.center) {
  padding: 0;
}

:host(:not(:last-of-type)) {
  .component {
    border-bottom: 1px solid $color-accordion-border;
  }
}

.component {
  position: relative;
}

:host(:not(:last-of-type).sdx--dark-theme) {
  .component {
    border-color: $color-gray-tint-7-dark-theme;
  }
}
